export interface Chapter {
  no: number;
  title: string;
  update: string;
}

export interface Work {
  id: string;
  title: string;
  category: string;
  tags: string[];
  cover: string;
  author: string;
  status: "连载中" | "已完结";
  rating: number;
  views: string;
  collected: string;
  updateLabel: string;
  intro: string;
  introDetail: string[];
  chapters: Chapter[];
}

export const works: Work[] = [
  {
    id: "wuwuchengan",
    title: "雾城谜案",
    category: "xuangyi",
    tags: ["悬疑", "都市", "迷雾"],
    cover: "https://readdy.ai/api/search-image?query=noir%20mystery%20manga%20cover%20of%20a%20detective%20standing%20in%20thick%20foggy%20city%20streets%20under%20dim%20streetlights%2C%20dark%20crimson%20and%20gold%20tone%2C%20cinematic%20atmosphere%2C%20dramatic%20shadows%2C%20intricate%20linework%2C%20vertical%20composition&width=400&height=560&seq=cover-wuchengan&orientation=portrait",
    author: "白雾绘",
    status: "连载中",
    rating: 9.4,
    views: "1286.5万",
    collected: "42.1万",
    updateLabel: "今日更新",
    intro: "终年被浓雾笼罩的临海小城，接连发生三起看似互不相干的失踪案。刚刚调任的刑警林远在整理旧档时，发现所有案件都指向同一栋废弃钟楼——而那栋钟楼，在三十年前就已经被彻底拆除。",
    introDetail: [
      "迷雾之下，无人可以信任。",
      "林远追查真相时，发现自己的父亲正是当年处理过同一案件的负责人，而父亲的笔记中，记录着一个本不该存在的名字。",
      "每一次接近真相，都让雾更浓一分。当最后一个目击者消失后，林远意识到——凶手或许一直就藏在警局内部。",
    ],
    chapters: [
      { no: 1, title: "迷雾下的失踪者", update: "今日更新" },
      { no: 2, title: "废弃钟楼", update: "7月12日" },
      { no: 3, title: "父亲的笔记", update: "7月8日" },
      { no: 4, title: "警局内部的影子", update: "6月30日" },
      { no: 5, title: "第三起案件", update: "6月22日" },
      { no: 6, title: "雾越来越浓", update: "6月14日" },
    ],
  },
  {
    id: "jiyiliefeng",
    title: "记忆裂缝",
    category: "xuangyi",
    tags: ["悬疑", "记忆", "心理"],
    cover: "https://readdy.ai/api/search-image?query=psychological%20thriller%20manga%20cover%20of%20a%20figure%20with%20cracked%20fractured%20mirror%20reflection%20split%20into%20pieces%2C%20moody%20dark%20crimson%20lighting%2C%20shattered%20glass%20shards%2C%20surreal%20anxiety%20atmosphere%2C%20intricate%20detail%2C%20vertical%20cover%20art&width=400&height=560&seq=cover-jiyiliefeng&orientation=portrait",
    author: "碎片实验室",
    status: "连载中",
    rating: 9.1,
    views: "976.3万",
    collected: "35.6万",
    updateLabel: "3天前更新",
    intro: "一次车祸后，心理医生苏黎失去了过去五年的记忆。然而梦里的片段告诉她，这场车祸或许根本不是意外。她试图拼凑记忆的碎片，却发现每找回一段记忆，就会失去一个身边的人。",
    introDetail: [
      "记忆是假的，感受是真的吗？",
      "苏黎在旧物里找到一段录像，录像中的自己正对着镜头说：『千万别相信我找回的记忆。』",
      "当裂缝逐渐闭合，真相也随之坍塌。究竟谁在篡改她的过去？",
    ],
    chapters: [
      { no: 1, title: "失忆的五年", update: "3天前" },
      { no: 2, title: "录像带里的警告", update: "7月9日" },
      { no: 3, title: "消失的同事", update: "7月2日" },
      { no: 4, title: "裂缝闭合", update: "6月25日" },
    ],
  },
  {
    id: "daojishi",
    title: "倒计时证人",
    category: "tuili",
    tags: ["推理", "倒计时", "证人"],
    cover: "https://readdy.ai/api/search-image?query=deduction%20manga%20cover%20of%20a%20sole%20witness%20silhouette%20holding%20a%20pocket%20watch%20under%20an%20oversized%20clock%20with%20countdown%2C%20warm%20gold%20and%20deep%20crimson%20lighting%2C%20tense%20mystery%20atmosphere%2C%20dramatic%20composition%2C%20vertical%20cover&width=400&height=560&seq=cover-daojishi&orientation=portrait",
    author: "分秒堂",
    status: "连载中",
    rating: 9.6,
    views: "1523.8万",
    collected: "51.2万",
    updateLabel: "今日更新",
    intro: "神秘组织『钟摆』在每个案件发生前，都会向警方寄出一张倒计时照片。唯一的目击者、摄影师顾言，被卷入一场跨越十年的连环案件。每一次倒计时归零，都意味着一个新的受害者出现。",
    introDetail: [
      "倒计时开始，真相悄然逼近。",
      "顾言发现照片里的每一处细节，都在暗示案件的最终答案——而答案的尽头，指向他自己。",
      "当第十张照片寄出，倒计时指向的，是那个永远停摆的钟。",
    ],
    chapters: [
      { no: 1, title: "第一张照片", update: "今日更新" },
      { no: 2, title: "钟摆组织", update: "7月13日" },
      { no: 3, title: "第八张倒计时", update: "7月5日" },
      { no: 4, title: "第十个数字", update: "6月27日" },
    ],
  },
  {
    id: "lianhuansaizheng",
    title: "连环罪证",
    category: "tuili",
    tags: ["推理", "连环案", "罪证"],
    cover: "https://readdy.ai/api/search-image?query=crime%20deduction%20manga%20cover%20of%20a%20detective%20examining%20a%20board%20of%20clues%20and%20evidence%20photographs%20linked%20by%20red%20threads%2C%20dark%20background%20with%20crimson%20accents%2C%20focused%20moody%20lighting%2C%20intricate%20detail%2C%20vertical%20cover&width=400&height=560&seq=cover-lianhuan&orientation=portrait",
    author: "证据链工作室",
    status: "连载中",
    rating: 9.3,
    views: "1089.2万",
    collected: "38.9万",
    updateLabel: "2天前更新",
    intro: "十年前，连环案件的真凶落网，轰动一时。十年后，同一模样的新案件再度发生——手法一模一样，却多了一个本不该存在的细节。法医周野与老刑警重启调查，却发现当年案件的证物早已被人调换。",
    introDetail: [
      "每一份证物，都是伏笔。",
      "真凶明明已经伏法，为何案件还在继续？",
      "当所有证据链条重新拼合，指向的竟是当年亲手结案的那个人。",
    ],
    chapters: [
      { no: 1, title: "十年后的重演", update: "2天前" },
      { no: 2, title: "被调换的证物", update: "7月10日" },
      { no: 3, title: "结案者的手", update: "7月3日" },
      { no: 4, title: "链条断裂", update: "6月26日" },
    ],
  },
  {
    id: "pingxingzuian",
    title: "平行罪案",
    category: "shaonao",
    tags: ["烧脑", "平行时空", "罪案"],
    cover: "https://readdy.ai/api/search-image?query=mindbending%20sci-fi%20manga%20cover%20of%20two%20mirrored%20city%20skylines%20overlapping%20with%20glitch%20grid%20lines%2C%20dark%20crimson%20and%20neon%20gold%20glow%2C%20surreal%20parallel%20universe%20atmosphere%2C%20high%20detail%2C%20vertical%20cover&width=400&height=560&seq=cover-pingxing&orientation=portrait",
    author: "因果研究所",
    status: "已完结",
    rating: 9.5,
    views: "1345.6万",
    collected: "47.8万",
    updateLabel: "已完结",
    intro: "物理学教授秦风发现，自己每次入睡后都会在另一个平行世界醒来。在那个世界里，他是一名通缉犯，而所有的案件，都源于他在这个世界未曾做出的选择。两个世界的命运被一条看不见的因果线紧紧相连。",
    introDetail: [
      "同一个我，不同的罪。",
      "为了解开两个世界的谜团，秦风必须找出那个改变一切的『分歧点』。",
      "当他终于找到分歧点时，却发现真正的幕后黑手，是那个世界的『自己』。",
    ],
    chapters: [
      { no: 1, title: "另一个我", update: "完结章" },
      { no: 2, title: "因果线", update: "完结章" },
      { no: 3, title: "分歧点", update: "完结章" },
      { no: 4, title: "最后的自己", update: "完结章" },
      { no: 5, title: "终点也是起点", update: "完结章" },
    ],
  },
  {
    id: "wujiedefangcheng",
    title: "无解的方程",
    category: "shaonao",
    tags: ["烧脑", "数学", "密室"],
    cover: "https://readdy.ai/api/search-image?query=mathematical%20thriller%20manga%20cover%20of%20a%20figure%20solving%20a%20giant%20glowing%20equation%20on%20a%20dark%20chalkboard%20inside%20a%20locked%20room%2C%20gold%20formulas%20and%20crimson%20shadows%2C%20tense%20intellectual%20atmosphere%2C%20vertical%20cover&width=400&height=560&seq=cover-fangcheng&orientation=portrait",
    author: "二进制迷",
    status: "连载中",
    rating: 9.2,
    views: "892.4万",
    collected: "31.7万",
    updateLabel: "4天前更新",
    intro: "七名陌生人醒来后，发现自己被困在一间只有一道数学题的黑板教室。题目看似无解，却暗藏着离开房间的唯一钥匙。天才少女莫语发现，每一道解题步骤，都在隐喻七个人之间隐瞒的秘密。",
    introDetail: [
      "这道题，无解却有答案。",
      "莫语每解开一题，房间就会消失一名同伴——而这正是题目真正的用意。",
      "当最后只剩她一人时，黑板上的题目终于露出了完整的真相。",
    ],
    chapters: [
      { no: 1, title: "黑板教室", update: "4天前" },
      { no: 2, title: "第一道无解之题", update: "7月6日" },
      { no: 3, title: "消失的同伴", update: "6月29日" },
      { no: 4, title: "最后一人", update: "6月21日" },
    ],
  },
  {
    id: "zuihouyiyefanzhuan",
    title: "最后一页反转",
    category: "fanzhuan",
    tags: ["反转", "惊悚", "短篇"],
    cover: "https://readdy.ai/api/search-image?query=plot%20twist%20horror%20manga%20cover%20of%20an%20open%20book%20with%20pages%20flying%20revealing%20a%20sinister%20silhouette%20behind%20the%20last%20page%2C%20dark%20crimson%20and%20gold%20tones%2C%20dramatic%20eerie%20atmosphere%2C%20vertical%20cover&width=400&height=560&seq=cover-yefanzhuan&orientation=portrait",
    author: "反转剧场",
    status: "连载中",
    rating: 9.4,
    views: "1678.1万",
    collected: "58.3万",
    updateLabel: "今日更新",
    intro: "连载人气超高的反转短篇合集，每一话都独立成篇，却又在最后一页颠覆你此前看到的一切。当你以为真相大白时，真正的结局才缓缓拉开帷幕。",
    introDetail: [
      "反转之后再反转，防不胜防。",
      "每一话的故事，都值得从头再读一遍。",
      "那些你忽略的细节，正是最后翻盘的关键。",
    ],
    chapters: [
      { no: 1, title: "第24话：窗外的影子", update: "今日更新" },
      { no: 2, title: "第23话：送错的快递", update: "7月11日" },
      { no: 3, title: "第22话：完美的邻居", update: "7月4日" },
      { no: 4, title: "第21话：生日快乐", update: "6月27日" },
    ],
  },
  {
    id: "weizhuangzhe",
    title: "伪装者",
    category: "fanzhuan",
    tags: ["反转", "双面", "身份"],
    cover: "https://readdy.ai/api/search-image?query=identity%20twist%20manga%20cover%20of%20a%20figure%20removing%20a%20mask%20revealing%20another%20face%20underneath%2C%20half%20shadow%20half%20light%2C%20dark%20crimson%20backdrop%2C%20golden%20rim%20light%2C%20dramatic%20vertical%20cover&width=400&height=560&seq=cover-weizhuang&orientation=portrait",
    author: "双面绘师",
    status: "连载中",
    rating: 9.0,
    views: "754.2万",
    collected: "26.9万",
    updateLabel: "5天前更新",
    intro: "特工简亦在执行任务时发现，自己朝夕相处的搭档，竟然就是所有案件背后真正的幕后人。而当她决定揭穿对方时，对方却拿出了一张她和早已牺牲的『叛徒』并肩而立的照片。",
    introDetail: [
      "最危险的人，往往就在身边。",
      "简亦开始怀疑，究竟谁才是真正的伪装者。",
      "当所有面具被逐一揭下，藏在最里面的那张脸，竟是她自己。",
    ],
    chapters: [
      { no: 1, title: "身边的面具", update: "5天前" },
      { no: 2, title: "那张旧照片", update: "7月7日" },
      { no: 3, title: "揭下面具", update: "6月30日" },
    ],
  },
  {
    id: "diqimatoutouxiong",
    title: "第七码头凶案",
    category: "anjian",
    tags: ["案件", "凶案", "码头"],
    cover: "https://readdy.ai/api/search-image?query=crime%20case%20manga%20cover%20of%20a%20pier%20dock%20at%20night%20with%20police%20tape%20and%20a%20detective%20flashlight%20beam%2C%20dark%20blue-free%20crimson%20and%20amber%20lighting%2C%20rainy%20moody%20atmosphere%2C%20vertical%20cover&width=400&height=560&seq=cover-matou&orientation=portrait",
    author: "码头故事局",
    status: "连载中",
    rating: 8.9,
    views: "633.5万",
    collected: "24.1万",
    updateLabel: "6天前更新",
    intro: "第七码头深夜的凶案现场，唯一的监控在案发前五分钟莫名损坏。刑警程墨重查旧案时，发现这起案件竟与十二年前同一地点的另一桩悬案存在惊人的相似之处。",
    introDetail: [
      "同一个码头，两种真相。",
      "程墨沿着锈迹斑斑的铁链一路追查，真相沉在水面之下。",
      "当潮水退去，被掩埋的证据终于浮出水面。",
    ],
    chapters: [
      { no: 1, title: "午夜码头", update: "6天前" },
      { no: 2, title: "损坏的监控", update: "7月8日" },
      { no: 3, title: "十二年前的悬案", update: "7月1日" },
    ],
  },
  {
    id: "hongxie",
    title: "红鞋",
    category: "anjian",
    tags: ["案件", "都市", "诡异"],
    cover: "https://readdy.ai/api/search-image?query=mysterious%20case%20manga%20cover%20of%20a%20single%20red%20shoe%20on%20a%20dark%20wet%20alleyway%20ground%2C%20haunting%20crimson%20and%20gold%20lighting%2C%20cerie%20fog%2C%20intricate%20shadows%2C%20vertical%20cover&width=400&height=560&seq=cover-hongxie&orientation=portrait",
    author: "旧巷绘卷",
    status: "连载中",
    rating: 9.1,
    views: "845.7万",
    collected: "30.2万",
    updateLabel: "3天前更新",
    intro: "一条总在午夜出现在不同地点的红色高跟鞋，牵动着数起看似无关的案件。民俗学者顾晚晚被卷入其中，她发现这双鞋的传说，竟与当地一段被刻意抹去的家族历史有关。",
    introDetail: [
      "一只红鞋，一段被埋葬的往事。",
      "顾晚晚循着传说一路追查，真相却被一群人不惜一切代价隐瞒。",
      "当红鞋再次出现时，那个隐藏百年的秘密即将被揭开。",
    ],
    chapters: [
      { no: 1, title: "午夜红鞋", update: "3天前" },
      { no: 2, title: "被抹去的历史", update: "7月9日" },
      { no: 3, title: "百年家族", update: "7月2日" },
      { no: 4, title: "鞋的主人", update: "6月25日" },
    ],
  },
  {
    id: "mishituotuozhinan",
    title: "密室逃脱指南",
    category: "jiemi",
    tags: ["解密", "密室", "机关"],
    cover: "https://readdy.ai/api/search-image?query=escape%20room%20decoding%20manga%20cover%20of%20a%20character%20holding%20a%20compass%20in%20a%20room%20full%20of%20hidden%20mechanisms%20and%20gears%2C%20warm%20gold%20lighting%20with%20deep%20crimson%20shadows%2C%20adventurous%20mystery%20atmosphere%2C%20vertical%20cover&width=400&height=560&seq=cover-mishi&orientation=portrait",
    author: "齿轮密码社",
    status: "已完结",
    rating: 9.2,
    views: "987.1万",
    collected: "34.6万",
    updateLabel: "已完结",
    intro: "解密师齐夏受雇进入一座据说『从无人能活着离开』的古老宅邸，破解深藏其中的机关谜题。每解开一道门，就会获得一段关于宅邸主人身世的线索——直到她发现，自己正是这座宅邸失散多年的继承人。",
    introDetail: [
      "每一道机关，都是一段家书。",
      "齐夏用智慧与胆识，在层层谜局中寻找回家的路。",
      "当最后一道门打开，尘封的家族真相也随之大白。",
    ],
    chapters: [
      { no: 1, title: "古宅的邀请", update: "完结章" },
      { no: 2, title: "齿轮之门", update: "完结章" },
      { no: 3, title: "血脉的线索", update: "完结章" },
      { no: 4, title: "最后一道门", update: "完结章" },
    ],
  },
  {
    id: "shiyizhedangan",
    title: "失忆者档案",
    category: "jiemi",
    tags: ["解密", "失忆", "档案"],
    cover: "https://readdy.ai/api/search-image?query=archive%20decoding%20manga%20cover%20of%20a%20figure%20opening%20a%20vault%20of%20old%20classified%20files%20and%20photos%2C%20mysterious%20crimson%20and%20gold%20mood%2C%20dusty%20dark%20archive%20atmosphere%2C%20dramatic%20lighting%2C%20vertical%20cover&width=400&height=560&seq=cover-shiyizhe&orientation=portrait",
    author: "档案室第13排",
    status: "连载中",
    rating: 8.8,
    views: "612.9万",
    collected: "22.4万",
    updateLabel: "6天前更新",
    intro: "失忆者组织『档案室』收容所有找不到身份记忆的人。管理员阿澈在一次例行整理中，偶然打开了自己的档案，却发现档案上写着的失踪日期，就在明天。",
    introDetail: [
      "明天，我将消失。",
      "阿澈必须赶在『明天』之前，解开自己身份的谜团。",
      "而他每打开一份档案，都会有另一个失忆者的记忆随之苏醒。",
    ],
    chapters: [
      { no: 1, title: "第13排档案", update: "6天前" },
      { no: 2, title: "明天的失踪", update: "7月7日" },
      { no: 3, title: "苏醒的记忆", update: "6月30日" },
    ],
  },
];

export const workById = (id: string): Work | undefined =>
  works.find((w) => w.id === id);

export const worksByCategory = (slug: string): Work[] =>
  works.filter((w) => w.category === slug);